export default [
    { id: "Aws", name: "Amazon Web Services", value: "aws" },
    { id: "Azurerm", name: "Microsoft Azure", value: "azurerm" },
    { id: "Google", name: "Google Cloud Platform", value: "google" }
]